import React, { useEffect, useState } from "react";
import { styled } from "baseui";
import { Panel } from "baseui/accordion";
import { Checkbox, LABEL_PLACEMENT } from "baseui/checkbox";
import {
  INDUSTRIES_LIST,
  TOPICS_LIST,
  TEMPLATE_SOLVERS_LIST,
} from "../../constants/TemplatesConstants";
import useRouteParams from "../../hooks/useRouteParams";
const AsideContainer = styled("div", ({ $theme }) => ({}));

const panelOverrides = {
  Header: {
    style: ({ $theme }) => ({
      backgroundColor: $theme.colors.accent100,
      borderRadius: "5px 5px 5px 5px",
    }),
  },
  Content: {
    style: ({ $theme }) => ({
      borderRadius: "0 0 5px 5px",
    }),
  },
  PanelContainer: {
    style: ({ $theme }) => ({
      marginBottom: "10px",
    }),
  },
  ToggleIcon: {
    style: ({ $theme }) => ({
      color: $theme.colors.contentPrimary,
    }),
  },
};
const updateCheckedFromSearchParams = (categoryList, paramValue) => {
  const checkedItems = paramValue ? paramValue.split(",").reduce((acc, cur) => ({ ...acc, [cur.toUpperCase()]: true }), {}) : {};
  return categoryList.reduce((acc, { id }) => ({ ...acc, [id]: !!checkedItems[id] }), {});
};
export default function ListAsideView({ onFilterSelectChange }) {
  const {searchParams} = useRouteParams();
  const [solversExpanded, setSolversExpanded] = useState(true);
  const [topicsExpanded, setTopicsExpanded] = useState(true);
  const [industriesExpanded, setIndustriesExpanded] = useState(true);  
  const [solversChecked, setSolversChecked] = useState(updateCheckedFromSearchParams(TEMPLATE_SOLVERS_LIST, searchParams.solvers));
  const [topicsChecked, setTopicsChecked] = useState(TOPICS_LIST, searchParams.topics);
  const [industriesChecked, setIndustriesChecked] = useState(updateCheckedFromSearchParams(INDUSTRIES_LIST, searchParams.industries));

  // Parse search params and update state accordingly
  useEffect(() => {
    setSolversChecked(updateCheckedFromSearchParams(TEMPLATE_SOLVERS_LIST, searchParams.solvers));
    setTopicsChecked(updateCheckedFromSearchParams(TOPICS_LIST, searchParams.topics));
    setIndustriesChecked(updateCheckedFromSearchParams(INDUSTRIES_LIST, searchParams.industries));
  }, [searchParams.solvers, searchParams.topics, searchParams.industries]);



  const handleCheckboxChange = (filterCategory, itemId) => {
    // Create a copy of the relevant state
    const stateCopies = {
      solvers: { ...solversChecked },
      topics: { ...topicsChecked },
      industries: { ...industriesChecked },
    };
    const updatedState = stateCopies[filterCategory];

    // Update the copied state
    updatedState[itemId] = !updatedState[itemId];
    // Update the component state after calling onFilterSelectChange
    if (filterCategory === 'solvers') {
      setSolversChecked(updatedState);
    } else if (filterCategory === 'topics') {
      setTopicsChecked(updatedState);
    } else if (filterCategory === 'industries') {
      setIndustriesChecked(updatedState);
    }
    // Construct query part for a given category
    const constructQueryPart = (items) => 
      Object.entries(items)
        .filter(([_, checked]) => checked)
        .map(([key]) => key.toLowerCase())
        .join(',');

    // Construct the query string from the updated states
    const queryString = Object.entries(stateCopies)
      .map(([category, items]) => `${category}=${constructQueryPart(items)}`)
      .filter(part => part.split('=')[1] !== '')
      .join('&');

    // Call the onFilterSelectChange function with the constructed query string
    onFilterSelectChange(queryString);


  };

  return (
    <AsideContainer>
      <Panel
        overrides={panelOverrides}
        style={{ marginBottom: "20px" }}
        title="Solvers"
        expanded={solversExpanded}
        onChange={() => setSolversExpanded(!solversExpanded)}
      >
        {TEMPLATE_SOLVERS_LIST.map((solver) => (
          <Checkbox
            key={solver.id}
            checked={!!solversChecked[solver.id]}
            onChange={() => handleCheckboxChange('solvers', solver.id)}
            labelPlacement={LABEL_PLACEMENT.right}
          >
            {solver.label}
          </Checkbox>
        ))}
      </Panel>
      <Panel
        overrides={panelOverrides}
        title="Topics"
        expanded={topicsExpanded}
        onChange={() => setTopicsExpanded(!topicsExpanded)}
      >
        {TOPICS_LIST.map((topic) => (
          <Checkbox
            key={topic.id}
            checked={!!topicsChecked[topic.id]}
            onChange={() => handleCheckboxChange('topics', topic.id)}
            labelPlacement={LABEL_PLACEMENT.right}
          >
            {topic.label}
          </Checkbox>
        ))}
      </Panel>
      <Panel
        overrides={panelOverrides}
        title="Industries"
        expanded={industriesExpanded}
        onChange={() => setIndustriesExpanded(!industriesExpanded)}
      >
        {INDUSTRIES_LIST.map((industry) => (
          <Checkbox
            key={industry.id}
            checked={!!industriesChecked[industry.id]}
            onChange={() => handleCheckboxChange('industries', industry.id)}
            labelPlacement={LABEL_PLACEMENT.right}
          >
            {industry.label}
          </Checkbox>
        ))}
      </Panel>
    </AsideContainer>
  );
}
